import {ControlBuilder} from '../../dynamic-field/control-builder.type';
import {SlideToggleFieldConfig} from './slide-toggle-field.config';
import {FilterSelectFieldConfig} from "../filter-select/filter-select-field.config";
import {ValidatorFn} from "@angular/forms";
import {buildAsyncValidators, buildDefaultValidators} from "../../dynamic-field/default-control-builder";

export const SlideToggleFieldControlBuilder: ControlBuilder = (fieldConfig: SlideToggleFieldConfig, formBuilder) => {

    let {disabled, value} = fieldConfig;

    const validators = buildDefaultValidators(fieldConfig);

    const asyncValidators = buildAsyncValidators(fieldConfig);
     value = value || false;
    return formBuilder.control(
        {
            disabled,
            value
        },
        validators,
        asyncValidators
    );
};
export const SlideToggleFieldValidators: (fieldConfig: FilterSelectFieldConfig) => ValidatorFn[] =
    (config): ValidatorFn[] => {
        const validators = buildDefaultValidators(config);

        return validators;
    };

